import { useMytaverse } from '@providers/MytaverseProvider';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();

  const { helperTextColor, helperTextLinkColor } = appTheme.loginPage.assets;

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '36px',
      width: '100%',
      maxWidth: 480,
    },
    text: {
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      textAlign: 'center',
      color: helperTextColor,
      width: '80%',
      alignSelf: 'center',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        width: '100%',
      },
    },
    link: {
      color: helperTextLinkColor,
      textDecoration: 'none',
      // Reset native button styles so a `component="button"` link matches the
      // surrounding text (it opens the terms dialog instead of navigating).
      border: 'none',
      background: 'none',
      padding: 0,
      cursor: 'pointer',
      font: 'inherit',
      verticalAlign: 'baseline',
    },
  };
};
